import { Button, Tooltip } from "antd";
import styles from "./custom-button.module.css";

const activeStyle = {
  background: "var(--Teal-Semi-dark, var(--primary-color))",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  height: "36px",
};

export function CustomButton({
  title = "",
  type,
  size,
  shape,
  loading,
  iconPosition,
  icon,
  color,
  className,
  style,
  disabled,
  onClick,
  showTooltip = false,
  tooltipPlacement,
  tooltipText,
  variant,
  htmlType,
}) {
  return (
    <Tooltip
      placement={tooltipPlacement}
      title={showTooltip ? tooltipText || title : ""}
    >
      <Button
        className={className}
        color={color}
        disabled={disabled}
        icon={icon}
        iconPosition={iconPosition}
        loading={loading}
        shape={shape}
        size={size}
        style={
          !disabled ? (type !== "text" ? { ...activeStyle, ...style } : {}) : {}
        } // 🔹 Merge default & user styles
        type={type}
        onClick={onClick}
        variant={variant}
        htmlType={htmlType}
      >
        {title}
      </Button>
    </Tooltip>
  );
}

export default CustomButton;
